<script>
  import { table_pos, nicks_list, map_ready, live, menu } from "./stores.js";
  import { onMount, onDestroy } from "svelte";
  import {
    acquireMainMap,
    createVectorMapOptions,
    isMainMapOwner,
    MAP_RESET_VIEW,
    releaseMainMap,
  } from "./map-pool.js";
  import {
    INICIO_RENDER_DEBOUNCE_MS,
    buildInicioDashboardState,
    createInicioMarkerOptions,
    reconcileInicioMarkerSnapshots,
  } from "./inicio-dashboard-utils.js";

  let mount_complete = false;
  const INICIO_CLUSTER_IMAGE_PATH = "img/m";

  const style = document.createElement("style");
  style.innerHTML = `
    .custom-label {
      background-color: white; /* Fondo blanco */
      padding: 2px 5px; /* Espaciado interno */
      border-radius: 3px; /* Bordes redondeados */
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); /* Sombra */
      white-space: nowrap; /* Evita que el texto se divida en varias líneas */
    }
  `;
  document.head.appendChild(style);

  var chart1 = {
    type: "line",
    data: {
      labels: [],
      datasets: [
        {
          label: "km/h",
          data: [],
          backgroundColor: "rgba(255, 159, 64, 0.2)",
          borderColor: "rgb(255, 159, 64)",
        },
      ],
    },
    options: {
      animation: {
        duration: 0,
      },
      title: {
        display: true,
        fontSize: 14,
        padding: 10,
        text: "Estatus de Velocidad",
      },
      maintainAspectRatio: false,
      tooltips: { mode: "" },
      legend: {
        display: true,
        position: "top",
      },
    },
  };

  var chart2 = {
    type: "bar",
    data: {
      labels: ["Parking", "Idle", "Moving"],
      datasets: [
        {
          label: "Estado",
          data: [0, 0, 0],
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(255, 159, 64, 0.2)",
            "rgba(255, 205, 86, 0.2)",
          ],
          borderColor: [
            "rgb(255, 99, 132)",
            "rgb(255, 159, 64)",
            "rgb(255, 205, 86)",
          ],
          borderWidth: 1,
        },
      ],
    },
    options: {
      animation: {
        duration: 0,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              offsetGridLines: true,
            },
          },
        ],
        yAxes: [
          {
            ticks: { beginAtZero: true },
          },
        ],
      },
      title: {
        display: true,
        fontSize: 14,
        padding: 10,
        text: "Estatus de Movimiento",
      },
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: "top",
      },
    },
  };

  var chart3 = {
    type: "pie",
    data: {
      datasets: [
        {
          data: [0, 100],
          backgroundColor: ["rgb(255, 205, 86, 0.5)", "rgb(54, 162, 235, 0.5)"],
        },
      ],
      labels: ["Encendidas", "Apagadas"],
    },
    options: {
      animation: {
        duration: 0,
      },
      title: {
        display: true,
        fontSize: 14,
        padding: 10,
        text: "Apagadas vs Encendidas",
      },
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: "top",
      },
    },
  };

  var chart_1,
    chart_2,
    chart_3,
    map = 0;
  let map_host;
  let inicio_refresh_timer = null;

  onMount(() => {
    chart_1 = new Chart(
      document.getElementById("chart1").getContext("2d"),
      chart1
    );
    chart_2 = new Chart(
      document.getElementById("chart2").getContext("2d"),
      chart2
    );
    chart_3 = new Chart(
      document.getElementById("chart3").getContext("2d"),
      chart3
    );
    mount_complete = true;
    try {
      twttr.widgets.load();
    } catch (e) {}
    scheduleInicioRefresh();
  });

  function initMap() {
    map = acquireMainMap("inicio", map_host, {
      mapOptions: createVectorMapOptions(),
      resetView: MAP_RESET_VIEW.DEFAULT,
      cleanup: cleanup_inicio_map,
      recreateOnRelease: true,
    });
    scheduleInicioRefresh();
  }

  $: {
    if ($map_ready == 1 && mount_complete && map_host != null && map == 0) {
      initMap();
      console.log("mapa cargado");
    }
  }

  $: {
    if ($menu != 1 && isMainMapOwner("inicio")) {
      releaseMainMap("inicio", cleanup_inicio_map);
    }
  }

  $: {
    if (mount_complete) {
      $table_pos;
      $live;
      $nicks_list;
      scheduleInicioRefresh();
    }
  }

  function clearInicioRefreshTimer() {
    if (inicio_refresh_timer) {
      clearTimeout(inicio_refresh_timer);
      inicio_refresh_timer = null;
    }
  }

  function scheduleInicioRefresh() {
    if (!mount_complete || inicio_refresh_timer) {
      return;
    }

    inicio_refresh_timer = setTimeout(() => {
      inicio_refresh_timer = null;
      renderInicioDashboard();
    }, INICIO_RENDER_DEBOUNCE_MS);
  }

  function applyInicioCharts(dashboardState) {
    if (!dashboardState) {
      return;
    }

    const { counts, movingSpeedValues } = dashboardState;
    const sortedSpeedValues = movingSpeedValues.slice().sort((a, b) => b - a);

    if (typeof chart_1 != "undefined") {
      chart_1.data.datasets[0].data = sortedSpeedValues;
      chart_1.data.labels = Array(sortedSpeedValues.length).fill(" ");
      chart_1.update();
    }

    if (
      typeof chart_2 != "undefined" &&
      (counts.s0 != s0 || counts.s1 != s1 || counts.s2 != s2)
    ) {
      s0 = counts.s0;
      s1 = counts.s1;
      s2 = counts.s2;
      chart_2.data.datasets[0].data[0] = s0;
      chart_2.data.datasets[0].data[1] = s1;
      chart_2.data.datasets[0].data[2] = s2;
      chart_2.update();
    }

    if (
      typeof chart_3 != "undefined" &&
      (counts.on != on || counts.off != off)
    ) {
      on = counts.on;
      off = counts.off;
      chart_3.data.datasets[0].data[0] = on;
      chart_3.data.datasets[0].data[1] = off;
      chart_3.update();
    }
  }

  function renderInicioDashboard() {
    const dashboardState = buildInicioDashboardState(
      $table_pos,
      $live,
      $nicks_list
    );

    table_pos_ = dashboardState.rows;
    applyInicioCharts(dashboardState);

    if (map != 0) {
      reconcileInicioMapMarkers(dashboardState.markerEntries);
    }
  }

  function reconcileInicioMapMarkers(nextEntries) {
    if (map == 0) {
      return;
    }

    const { nextSnapshots, additions, updates, removals } =
      reconcileInicioMarkerSnapshots(marker_snapshots, nextEntries);

    for (const entry of updates) {
      const marker = marker_index.get(entry.modid);
      if (!marker) {
        continue;
      }

      marker.setOptions(createInicioMarkerOptions(entry, map));
    }

    let shouldRepaintCluster = false;
    if (removals.length > 0) {
      const markersToRemove = [];
      for (const entry of removals) {
        const marker = marker_index.get(entry.modid);
        if (!marker) {
          continue;
        }

        markersToRemove.push(marker);
        marker_index.delete(entry.modid);
      }

      if (markersToRemove.length > 0) {
        if (typeof markerCluster !== "undefined") {
          markerCluster.removeMarkers(markersToRemove, true);
          shouldRepaintCluster = true;
        } else {
          for (const marker of markersToRemove) {
            marker.setMap(null);
          }
        }
      }
    }

    if (additions.length > 0) {
      if (typeof markerCluster === "undefined") {
        markerCluster = new MarkerClusterer(map, [], {
          imagePath: INICIO_CLUSTER_IMAGE_PATH,
        });
      }

      const markersToAdd = [];
      for (const entry of additions) {
        const marker = new google.maps.Marker(createInicioMarkerOptions(entry, map));
        marker_index.set(entry.modid, marker);
        markersToAdd.push(marker);
      }

      if (markersToAdd.length > 0) {
        markerCluster.addMarkers(markersToAdd, true);
        shouldRepaintCluster = true;
      }
    }

    marker_snapshots = nextSnapshots;
    if (shouldRepaintCluster && typeof markerCluster !== "undefined") {
      markerCluster.repaint();
    }
  }

  function cleanup_inicio_map() {
    if (typeof markerCluster !== "undefined") {
      markerCluster.clearMarkers();
      markerCluster.setMap(null);
      markerCluster = undefined;
    }

    for (let marker of marker_index.values()) {
      marker.setMap(null);
    }
    marker_index.clear();
    marker_snapshots = new Map();

    map = 0;
  }

  onDestroy(() => {
    clearInicioRefreshTimer();
    releaseMainMap("inicio", cleanup_inicio_map);
  });

  var on = 0,
    off = 0;
  var s0 = 0,
    s1 = 0,
    s2 = 0;
  var markerCluster;
  let marker_index = new Map();
  let marker_snapshots = new Map();
  var table_pos_ = [];
</script>

<main
  role="main"
  class="container-fluid h-100 pl-0 pr-0 mdc-top-app-bar--dense-fixed-adjust mdc-typography"
>
  <div class="row h-50 no-gutters">
    <div class="col-md-6 h-100">
      <div class="card h-100">
        <div class="card-body h-100" style="padding: 0;">
          <div class="table-responsive h-100">
            <table
              class="table table-striped table-bordered table-sm"
              style="margin-bottom: 0;"
            >
              <thead class="thead-light">
                <tr>
                  <th scope="col">Economico</th>
                  <th scope="col">Estado</th>
                  <th scope="col">Vel</th>
                  <th scope="col">Ign</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">GPS</th>
                  <th scope="col">Cell</th>
                  <th scope="col">Latitud</th>
                  <th scope="col">Longitud</th>
                </tr>
              </thead>
              <tbody>
                {#each table_pos_ as item (item.modid)}
                  <tr>
                    <th
                      scope="row"
                      on:click={() => {
                        map.setCenter({
                          lat: parseFloat(item.lat),
                          lng: parseFloat(item.lon),
                        });
                        map.setZoom(15);
                      }}
                      style="cursor: pointer; color: blue;"
                      >{typeof $nicks_list[item.modid] != "undefined"
                        ? $nicks_list[item.modid]
                        : item.modid}</th
                    >
                    <td
                      >{item.status == 0
                        ? "Parking"
                        : item.status == 1
                          ? "Idle"
                          : "Moving"}</td
                    >
                    <td
                      class:table-success={item.vel <= 80 && item.vel != 0}
                      class:table-secondary={item.vel == 0}
                      class:bg-warning={item.vel > 80 && item.vel < 100}
                      class:bg-danger={item.vel >= 100}>{item.vel}</td
                    >
                    <td
                      class:table-success={item.ingnition == 1}
                      class:table-secondary={item.ingnition == 0}
                      >{item.ingnition == "1" ? "ON" : "OFF"}</td
                    >
                    <td
                      >{moment(new Date(item.last_comm * 1000)).format(
                        "DD/MM/YY HH:mm:ss"
                      )}</td
                    >
                    <td
                      class:bg-danger={item.hdop > 1.5}
                      class:table-success={item.hdop <= 1.5}>{item.hdop}</td
                    >
                    <td
                      class:bg-danger={item.rssi >= 100}
                      class:table-success={item.rssi <= 90}
                      class:bg-warning={item.rssi > 90 && item.rssi < 100}
                      >{item.rssi}</td
                    >
                    <td>{item.lat}</td>
                    <td>{item.lon}</td>
                  </tr>
                {/each}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 h-100">
      <div class="card h-100">
        <div class="card-body h-100" style="padding: 0;">
          <div class="h-100" bind:this={map_host}></div>
        </div>
      </div>
    </div>
    <div class="col-md-3 h-100">
      <div class="card h-100">
        <div class="card-body h-100">
          <canvas id="chart2"></canvas>
        </div>
      </div>
    </div>
    <div class="col-md-3 h-100">
      <div class="card h-100">
        <div class="card-body h-100">
          <canvas id="chart3"></canvas>
        </div>
      </div>
    </div>
    <!---
    <div class="w-100"></div>
    <div class="col-md-2 h-100" style="overflow-y: overlay;">
      <a
        class="twitter-timeline"
        data-height="600"
        data-theme="light"
        data-chrome="nofooter noheader"
        href="https://twitter.com/CAPUFE?ref_src=twsrc%5Etfw"
        >Tweets by CAPUFE</a
      >
    </div>
    -->
    <div class="col-md-6 h-100">
      <div class="card h-100">
        <div class="card-body h-100">
          <canvas id="chart1"></canvas>
        </div>
      </div>
    </div>
  </div>
</main>

<style>
  .table-responsive {
    overflow-y: auto;
  }

  .table-responsive thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f8f9fa;
  }

  .card-body {
    padding: 1rem;
  }

  .table th,
  .table td {
    text-align: center;
    vertical-align: middle;
  }

  .table thead th {
    background-color: #343a40;
    color: white;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(52, 58, 64, 0.05);
  }

  .table-striped tbody tr:nth-of-type(even) {
    background-color: rgba(52, 58, 64, 0.1);
  }

  .table th,
  .table td {
    padding: 0.75rem;
  }

  .card {
    border: none;
    border-radius: 0.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .card-body {
    background: #f8f9fa;
  }

  canvas {
    display: block;
  }
</style>
